export default __webpack_public_path__ + "static/media/jaguar.d8614886.jpg";